import { atomWithKey as atom } from "./atomWithKey";


export const activitiesSectorsAtom = atom<any[]>({
    key: "activitiesSectorsAtom",
    default: [],
});

export const citiesAtom = atom<any[]>({
    key: "citiesAtom",
    default: [],
});

export const requestCorporateAccountDetailsAtom = atom<any>({
    key: "requestCorporateAccountDetailsAtom",
    default: {},
});
export const corporateFormSubmittedAtom = atom<boolean>({
    key: "corporateFormSubmittedAtom",
    default: false,
});